import styled from "styled-components";
import { BodyDefault, VerySmall } from "../typography/styled";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";

type RowProps = {
  back?:boolean,
  isProps?:boolean,
  hover?:boolean,
  hasDisplayTask?:boolean,
  $layout?:'table' | 'card',
  $cardRole?:'primary' | 'status' | 'field' | 'action' | 'utility',
  $fullWidth?:boolean,
}
type ActiveProp = {
  active?:boolean,
  isSmall?:any
  ref?:any
  $card?:boolean
}
type TitleProp = {
  withBack?:boolean
  isNotifications?:boolean,
  isRead?:boolean,
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius:${({theme}) => theme.radius.control};
  width:100%;
  /* overflow: hidden; */
`

export const TableWrapper = styled.div`
  width: 100%;
  min-width: 0;

  @media (min-width: 769px) and (max-width: 900px) {
    overflow-x: auto;
  }
`

export const TableToolbar = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  min-height: 40px;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    gap: 6px;
  }
`

export const TableControlsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
  margin-bottom: 10px;
`

export const CardToolbarControls = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  white-space: nowrap;

  > label {
    flex: 0 0 auto;
  }
`

export const ToolbarActions = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 40px;
`

export const ToolbarSelect = styled.div`
  flex: 0 1 220px;
  width: min(220px, 100%);
  min-width: 130px;

  @media (max-width: 420px) {
    flex: 1 1 150px;
    width: auto;
  }
`

export const ToolbarTitle = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  margin-right: auto;
  color: ${({theme}) => theme.palette[900]};
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;

  & + input {
    flex: 0 1 280px;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`

export const ToolbarMeta = styled.span`
  margin-left: auto;
  color: ${({theme}) => theme.grey[600]};
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`

export const ToolbarSearch = styled.input`
  flex: 1 1 280px;
  width: auto;
  min-width: 220px;
  max-width: 360px;
  height: 40px;
  padding: 0 12px;
  box-sizing: border-box;
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  outline: none;
  background: ${({theme}) => theme.palette[10]};
  color: ${({theme}) => theme.palette[900]};
  font: inherit;
  font-size: 15px;

  &::placeholder {
    color: ${({theme}) => theme.grey[600]};
  }

  &:focus {
    border-color: ${({theme}) => theme.accent[100]};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`

export const TableEmptyState = styled.div`
  padding: 28px 16px;
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  background: ${({theme}) => theme.base.white};
  color: ${({theme}) => theme.grey[700]};
  text-align: center;
  font-size: 15px;
  line-height: 20px;
`

export const ViewSwitcher = styled.div`
  display: inline-flex;
  gap: 4px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ViewButton = styled.button<{$active?:boolean}>`
  appearance: none;
  min-height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: ${({theme}) => theme.radius.control};
  background: ${({theme, $active}) => $active ? theme.accent[15] : 'transparent'};
  color: ${({theme, $active}) => $active ? theme.accent[100] : theme.grey[700]};
  font: inherit;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    color: ${({theme}) => theme.base.black};
    background: ${({theme, $active}) => $active ? theme.accent[15] : theme.grey[200]};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const SelectAllButton = styled.button`
  appearance: none;
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px 0 10px;
  border: 0;
  border-radius: ${({theme}) => theme.radius.control};
  background: ${({theme}) => theme.base.white};
  box-shadow: ${({theme}) => `inset 0 0 0 1px ${theme.grey[400]}, ${theme.shadows.control}`};
  color: ${({theme}) => theme.isDark ? theme.palette[900] : theme.grey[800]};
  font: inherit;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    box-shadow: ${({theme}) => `inset 0 0 0 1px ${theme.accent[100]}, ${theme.shadows.control}`};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => `inset 0 0 0 1px ${theme.accent[100]}, ${theme.isDark ? theme.shadows.focusDark : theme.shadows.focus}`};
  }
`

export const SelectAllBox = styled.span<{$state: 'none' | 'some' | 'all'}>`
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin: 2px;
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.radius.xs};
  background: ${({theme, $state}) => $state === 'none' ? theme.base.white : theme.isDark ? theme.primary[400] : theme.primary[600]};
  box-shadow: ${({theme, $state}) => $state === 'none' ? `inset 0 0 0 1px ${theme.grey[400]}` : 'none'};

  &::after {
    content: '';
    display: ${({$state}) => $state === 'none' ? 'none' : 'block'};
    box-sizing: border-box;
    ${({$state}) => $state === 'some' ? `
      width: 8px;
      height: 2px;
      border-radius: 1px;
      background: #FFFFFF;
    ` : `
      width: 5px;
      height: 9px;
      margin-top: -2px;
      border: solid #FFFFFF;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    `}
  }
`

export const SelectionBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px;
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.radius.control};
  background: ${({theme}) => theme.isDark ? 'rgba(40, 148, 255, 0.14)' : theme.accent[15]};
  box-shadow: ${({theme}) => `inset 0 0 0 1px ${theme.isDark ? 'rgba(40, 148, 255, 0.4)' : '#A4D3FF'}`};
`

export const SelectionBarLabel = styled.span`
  margin-right: auto;
  color: ${({theme}) => theme.isDark ? theme.accent[100] : '#0F7BE6'};
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
`

export const SelectionClearButton = styled.button`
  appearance: none;
  height: 40px;
  padding: 0 10px;
  border: 0;
  border-radius: ${({theme}) => theme.radius.control};
  background: transparent;
  color: ${({theme}) => theme.isDark ? theme.accent[100] : '#0F7BE6'};
  font: inherit;
  font-size: 15px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const CardChildMarker = styled.span`
  flex: none;
  width: 14px;
  color: ${({theme}) => theme.grey[400]};
  line-height: 24px;
`

export const CardDisclosureToggle = styled.button`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  margin: -2px -14px -14px;
  padding: 0 14px;
  border: 0;
  border-top: ${({theme}) => `1px solid ${theme.grey[300]}`};
  border-radius: ${({theme}) => `0 0 ${theme.radius.control} ${theme.radius.control}`};
  background: transparent;
  color: ${({theme}) => theme.accent[100]};
  font: inherit;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: ${({theme}) => theme.grey[100]};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => `inset 0 0 0 2px ${theme.accent[100]}`};
  }
`

export const CardDisclosureChevron = styled(SVG)<{$open?:boolean}>`
  width: 16px;
  height: 16px;
  transform: rotate(${({$open}) => $open ? '180deg' : '0deg'});
  transition: transform 0.2s ease-out;

  & path {
    fill: currentColor;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const CardDisclosurePanel = styled.div`
  min-width: 0;
  padding: 12px;
  border-radius: ${({theme}) => theme.radius.control};
  background: ${({theme}) => theme.grey[100]};
  box-shadow: ${({theme}) => `inset 0 0 0 1px ${theme.grey[300]}`};
  overflow-wrap: anywhere;
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 380px), 1fr));
  align-items: start;
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

type TableCardProps = {
  $selected?:boolean,
  $hasDisplayTask?:boolean,
  $failed?:boolean,
  $child?:boolean,
}

const cardRing = ({theme, $selected, $hasDisplayTask, $failed}:any) => {
  if ($selected) {
    return `inset 0 0 0 2px ${theme.isDark ? theme.primary[400] : theme.primary[600]}`;
  }
  if ($hasDisplayTask) {
    return 'inset 0 0 0 2px #E8B533';
  }
  if ($failed) {
    return `inset 0 0 0 2px ${theme.errors[600]}`;
  }
  return `inset 0 0 0 1px ${theme.grey[350]}`;
}

export const TableCard = styled.article<TableCardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  margin-left: ${({$child}) => $child ? '20px' : '0'};
  padding: 14px;
  box-sizing: border-box;
  background: ${({theme}) => theme.base.white};
  border-radius: ${({theme}) => theme.radius.control};
  box-shadow: ${(props) => `${cardRing(props)}, ${props.theme.shadows.control}`};

  &:focus-within {
    box-shadow: ${(props) => `${cardRing(props)}, ${props.theme.isDark ? props.theme.shadows.focusDark : props.theme.shadows.focus}`};
  }

  @media (max-width: 768px) {
    width: ${({$child}) => $child ? 'calc(100% - 20px)' : '100%'};
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
`

export const CardIdentity = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const CardStatus = styled.div<{$indented?:boolean}>`
  min-width: 0;
  margin-left: ${({$indented}) => $indented ? '32px' : '0'};
`

export const CardTask = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px;
  color: ${({theme}) => theme.isDark ? '#E8B533' : '#8A6A10'};
  background: ${({theme}) => theme.isDark ? 'rgba(58, 54, 31, 1)' : 'rgba(255, 247, 225, 1)'};
  border-radius: ${({theme}) => theme.radius.control};
  font-size: 14px;
  line-height: 20px;
  overflow-wrap: anywhere;

  > span:first-child {
    display: flex;
    flex: none;
  }
`

export const CardFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  min-width: 0;
  padding-top: 12px;
  border-top: ${({theme}) => `1px solid ${theme.grey[300]}`};

  @media (max-width: 360px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const CardUtilities = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  padding-top: 12px;
  border-top: ${({theme}) => `1px solid ${theme.grey[300]}`};
`

export const CardFieldLabel = styled.span`
  color: ${({theme}) => theme.grey[600]};
  font-size: 12px;
  line-height: 1;
  text-transform: uppercase;
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
  padding-left: 10px;
  background-color: ${({theme}) => theme.palette[200]};

  @media (max-width: 768px) {
    display: none;
  }
`

export const TableTitle = styled(VerySmall)`
  color:${({theme}) => theme.palette[900]};
  margin-right: 2px;
`

export const BodyTitle = styled.div<TitleProp>`
  color:${({theme}) => theme.base.black};
  letter-spacing: 0px;
  background-color: ${({withBack, theme}) => withBack ? theme.grey[300] : ''};
  border-radius: ${({theme}) => theme.radius.xs};
  padding:${({withBack}) => withBack ? '3px 4px' : ''};
  font-size:${({withBack}) => withBack ? '12px' : ''};
  line-height:${({withBack}) => withBack ? '15px' : ''};
  font-weight: ${({isNotifications, isRead}) => isNotifications && !isRead ? '500' : ''};
  box-sizing: border-box;
  /* word-break: break-word; */
  max-width: 400px;
  padding-right: 20px;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  margin: 0;

`
export const BodyName = styled(BodyDefault)<TitleProp>`
  color:${({theme}) => theme.accent[100]};
  letter-spacing: 0px;
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  font-weight: ${({isNotifications}) => isNotifications ? '500' : ''};
  gap:8px;
  margin-left: ${({isRead}) => isRead ? '16px' : '0px'};
  max-width:100%;
  word-break: break-word;
  padding-right: 20px;
  box-sizing: border-box;
`

export const BodyNameLink = styled(Link)<TitleProp>`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  margin:0px;
  padding:0px;
  color:${({theme}) => theme.accent[100]};
  letter-spacing: 0px;
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  font-weight: ${({isNotifications}) => isNotifications ? '500' : ''};
  gap:8px;
  margin-left: ${({isRead}) => isRead ? '16px' : '0px'};
  max-width:100%;
  word-break: break-word;
  padding-right: 20px;
  box-sizing: border-box;
  text-decoration: none;
  &:hover {
    cursor:pointer;
    /* background-color:${({theme}) => theme.grey[100] }; */
  }
`
export const ColumnWrapper = styled.div`
  display:flex;
  flex-direction: column;
  /* flex: auto 1; */
`
export const Row = styled.td.withConfig({
  shouldForwardProp: (prop) => !['back', 'isProps', 'hover', 'hasDisplayTask'].includes(prop),
})<RowProps>`
  background-color: ${({theme, hover, hasDisplayTask, $layout}) => $layout === 'card' ? 'transparent' : hasDisplayTask ? theme.isDark ? 'rgba(58, 54, 31, 1)' : 'rgba(255, 247, 225, 1)' : hover ? theme.grey[100] :  theme.base.white};
  border-bottom: ${({theme, back, $layout}) => $layout !== 'card' && !back ? `1px solid ${theme.grey[300]}` : 'none'};
  border-top: ${({theme, back, $layout}) => $layout !== 'card' && !back ? `1px solid ${theme.grey[300]}` : 'none'};
  /* display: flex; */
  align-items:flex-start;
  flex-direction: column;
  /* width:100%; */
  /* flex: auto 1; */
  /* align-items: flex-start; */
  /* box-sizing:border-box; */
  justify-content: ${({isProps}) => isProps ? 'flex-end' : 'flex-start'};
  /* transform: ${({isProps}) => isProps ? 'translate(50%)' : ''}; */
  min-height: ${({$layout}) => $layout === 'card' ? '0' : '42px'};
  min-width: 0;
  padding: ${({$layout}) => $layout === 'card' ? '0' : '11px 11px 11px 10px'};
  /* box-sizing:border-box; */
  position:relative;
  vertical-align:top;
  display: ${({$layout}) => $layout === 'card' ? 'flex' : ''};
  flex: ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'primary' ? '1 1 auto' : $layout === 'card' && $cardRole === 'action' ? '0 0 44px' : ''};
  flex-direction: ${({$layout}) => $layout === 'card' ? 'column' : ''};
  gap: ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'field' ? '4px' : '0'};
  grid-column: ${({$layout, $fullWidth}) => $layout === 'card' && $fullWidth ? '1 / -1' : 'auto'};

  ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'primary' ? `
    > div:first-of-type {
      align-items: flex-start !important;
      gap: 10px;
    }

    ${BodyNameLink}, ${BodyTitle} {
      max-width: 100%;
      padding-right: 0;
      font-size: 18px;
      line-height: 24px;
      font-weight: 500;
      overflow-wrap: anywhere;
    }
  ` : ''}

  ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'field' ? `
    ${BodyTitle} {
      max-width: 100%;
      padding: 0;
      font-size: 15px;
      line-height: 20px;
      overflow-wrap: anywhere;
    }
  ` : ''}

  ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'status' ? `
    ${BodyTitle} {
      max-width: 100%;
      padding: 0;
      font-size: 15px;
      line-height: 20px;
    }
  ` : ''}

  ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'action' ? `
    width: 44px;
    height: 44px;
    margin: -12px -12px -12px 0;
    z-index: 2;
  ` : ''}

  ${({$layout, $cardRole}) => $layout === 'card' && $cardRole === 'utility' ? `
    width: 100%;

    > div:first-of-type {
      min-width: 0;
    }
  ` : ''}
`
export const ListWrapper = styled.div<TitleProp>`
  display: flex;
  flex-direction: ${({withBack, theme}) => withBack ? 'row' : 'column'};
  gap: ${({withBack, theme}) => withBack ? '6px' : ''};
  flex-wrap: wrap;
  /* margin-bottom:11px; */
  /* height:42px; */
`
export const TableTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  &:hover{
    cursor: pointer;
  }
`

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
`

export const PropsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['active', 'isSmall'].includes(prop),
})<ActiveProp>`
  box-sizing: border-box;
  padding: 4px 0px;
  right:13px;
  /* top: 30px; */
  z-index: 10;
  position: absolute;
  background-color: ${({theme}) => theme.palette[10]};
  width: 240px;
  /* height: 224px; */
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius:${({theme}) => theme.radius.control};
  box-shadow: ${({theme}) => `${theme.shadows.hover}, ${theme.shadows.menu}`};
  transform:${({active}) => active ? 'scale(1)' : 'scale(0)'};
  opacity:${({active}) => active ? '1' : '0'};
  transition-property: transform, opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;

  ${({$card}) => $card ? `
    top: 44px;
    right: 0;
    width: 230px;
    max-width: calc(100vw - 60px);
    max-height: min(300px, calc(100dvh - 32px));
    overflow-y: auto;
    transform-origin: top right;

    button[role="menuitem"] {
      min-height: 44px;
      padding: 10px 12px;
    }
  ` : ''}

  @media (max-width: 768px) {
    right: 0;
    width: ${({$card}) => $card ? 'min(230px, calc(100vw - 60px))' : 'min(240px, calc(100vw - 64px))'};
    max-height: calc(100dvh - 32px);
    overflow-y: auto;
  }
`

export const TableCustom = styled.table`
  width: 100%;
  border-collapse:collapse!important;
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius:${({theme}) => theme.radius.control}!important;
  /* display:flex; */
  /* flex-direction:column; */

`;

export const Tr = styled.tr`
  /* display: flex;
  flex-direction: column; */
`


type ActivePropImg = {
  active?:boolean,
  disable?:boolean,
  hover?:boolean,
}
export const StyledIconMore = styled(SVG)<ActivePropImg>`
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  & path {
    fill: ${({ theme }) => theme.base.black};
  }
  opacity: ${({hover, disable}) => hover || disable ? '0.7' : ''};
  filter: ${({active, disable}) => active && !disable ? 'brightness(77%)' : ''};
  &:hover {
    cursor: pointer;
    opacity: ${({hover}) => hover ? '' : '0.7'};
  }
  &:active{
    filter: ${({disable}) => !disable ? 'brightness(77%)' : ''};
  }
`
